export const passwordValidationRules = {
  required: "Password is required",
  pattern: {
    value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
    message:
      "Password must be at least 8 characters and include at least one uppercase letter, one lowercase letter, and one number.",
  },
};
